export const Defaults = {
  primaryMetricId: 1,
  secondaryMetricId: -1,
  granularity: 'Day',
  graunlarityId: 1,
  showMovingAverage: false,
  showChart: true,
};

const originalPrimary = '#01188F';
const comparativePrimary = '#808CC7'; // 50% mix of originalPrimary and white
const originalSecondary = '#B40091';
const comparativeSecondary = '#D980C8'; // 50% mix of originalSecondary and white

export const seriesColor = {
  primary: {
    original: originalPrimary,
    comparative: comparativePrimary,
  },
  secondary: {
    original: originalSecondary,
    comparative: comparativeSecondary,
  },
};
